async function HeaderSave(
    headerid, configid, location, flowsp,
    outerbarsprayvoltage, outerbarrestingvoltage, outerbaridlevoltage,
    centerbarsprayvoltage, centerbarrestingvoltage, centerbaridlevoltage,
    nozzlesprayvoltage, nozzlerestingvoltage, nozzleidlevoltage,
    boostsprayvoltage, boostrestingvoltage, boostidlevoltage,
    highvoltageontime, highvoltageofftime,
    nozzleontime, nozzleofftime
) {

    if (true) {

        let response;

        let params = {
            "@HeaderID": headerid,
            "@ConfigID": configid,
            "@Location": location,
            "@FlowSP": flowsp,
            "@OuterBarSprayVoltage": outerbarsprayvoltage,
            "@OuterBarRestingVoltage": outerbarrestingvoltage,
            "@OuterBarIdleVoltage": outerbaridlevoltage,
            "@CenterBarSprayVoltage": centerbarsprayvoltage,
            "@CenterBarRestingVoltage": centerbarrestingvoltage,
            "@CenterBarIdleVoltage": centerbaridlevoltage,
            "@NozzleSprayVoltage": nozzlesprayvoltage,
            "@NozzleRestingVoltage": nozzlerestingvoltage,
            "@NozzleIdleVoltage": nozzleidlevoltage,
            "@BoostSprayVoltage": boostsprayvoltage,
            "@BoostRestingVoltage": boostrestingvoltage,
            "@BoostIdleVoltage": boostidlevoltage,
            "@HighVoltageOnTime": highvoltageontime,
            "@HighVoltageOffTime": highvoltageofftime,
            "@NozzleOnTime": nozzleontime,
            "@NozzleOffTime": nozzleofftime
        };

        response = await fetch("https://api.cssi.co/query", {
            method: "POST",
            body: JSON.stringify({
                "sp": "98",
                "parameters": params,
                "servername": "Compass-Svr3\\EXACTSQLEXPRESS",
                "databasename": "WebApps",
                "continuingfunction": null,
                "noresults": false,
                "args": null
            })
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })

        return Promise.resolve(response);

    }
}

export default HeaderSave;